export default "__VITE_ASSET__c5b10d2a__"